import { callApi } from '../../utils/apiCaller'
import { THEME_PATH } from '../routes'

export const fetchTheme = () => {
  return callApi(`${THEME_PATH}`, {
    method: 'get',
  })
}

export default {}
